"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _firestorePlus = require("firestore-plus");

var yup = _interopRequireWildcard(require("yup"));

var types = _interopRequireWildcard(require("../types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class UserSchema extends _firestorePlus.Schema {
  /**
   * Whatever object returned from here will take the place of
   * the data returned. Return nothing to return the original
   * object.
   * @param {*} data
   */
  static postValidate(data) {
    console.log("[UserSchema#postValidate]", data);
  }

}

exports.default = UserSchema;
UserSchema.fieldTypes = {
  createdAt: types.DateTime,
  fake: yup.bool(),
  avg_rating: yup.number(),
  rating_count: yup.number(),
  stripe_customer_id: yup.string(),
  stripe_user_id: yup.string(),
  social_verified: yup.bool(),
  newsletterSubscribed: yup.bool(),
  notification_preferences: yup.object().shape({
    email: yup.bool(),
    sms: yup.bool(),
    push: yup.bool()
  }),
  picture: yup.string().url(),
  phoneNumber: yup.string(),
  email: yup.string(),
  firstName: yup.string(),
  lastName: yup.string(),
  addresses: yup.string(),
  dob: yup.object().shape({
    day: yup.string(),
    month: yup.string(),
    year: yup.string()
  })
};
//# sourceMappingURL=User.js.map